<template>
  <div class="resource">
    <div class="sift">
      <div class="title">登录日志查询</div>
      <div class="inquire">
        <el-form :inline="true" :model="formInline" class="demo-form-inline" size="small">
          <el-form-item v-show="false">
            <strong slot="label">orgId</strong>
            <el-input v-model="formInline.orgId" placeholder="orgId" disabled></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">登录账号</strong>
            <el-input
              v-model="formInline.userName"
              placeholder="请输入登录账号"
              clearable
              @keyup.enter.native="inquire"
              @clear="inquire"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <strong slot="label">时间区间</strong>
            <el-date-picker
              v-model="formInline.dateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="inquire" style="background:#0C75E5">查询</el-button>
            <el-button icon="el-icon-refresh" @click="reset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="detail">
      <div class="title">登录日志列表</div>
      <el-table
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{background:'#F9F9FB',color:'#606266'}"
      >
        <el-table-column prop="userName" label="登录账号"></el-table-column>
        <el-table-column prop="source" label="来源" width="90">
          <template slot-scope="scope">
            {{ scope.row.source === 'C' ? '客户端' : '管理端' }}
          </template>
        </el-table-column>
        <el-table-column prop="ipaddr" label="登录IP"></el-table-column>
        <el-table-column prop="loginLocation" label="登录地点" show-overflow-tooltip></el-table-column>
        <el-table-column prop="browser" label="浏览器" show-overflow-tooltip></el-table-column>
        <el-table-column prop="os" label="操作系统" show-overflow-tooltip></el-table-column>
        <el-table-column prop="status" label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="scope.row.status === '0' ? 'success' : 'danger'">
              {{ scope.row.status === '0' ? '成功' : '失败' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="提示消息" show-overflow-tooltip></el-table-column>
        <el-table-column label="登录时间" width="170">
          <template slot-scope="scope">
            {{ scope.row.loginTime | filter_handleDateTime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[5, 10, 20, 30, 40]"
        :page-size="pageSize"
        layout="->, total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import url from '@/config/url'

export default {
  data() {
    const loginUser = JSON.parse(window.sessionStorage.getItem('loginUser') || '{}')
    return {
      formInline: {
        orgId: loginUser.orgId || '',
        userName: '',
        dateRange: []
      },
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      loading: true
    }
  },
  created() {
    this.getList()
  },
  methods: {
    inquire() {
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    reset() {
      const loginUser = JSON.parse(window.sessionStorage.getItem('loginUser') || '{}')
      this.formInline.orgId = loginUser.orgId || ''
      this.formInline.userName = ''
      this.formInline.dateRange = []
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    getList() {
      const beginTime = this.formInline.dateRange && this.formInline.dateRange.length ? this.formInline.dateRange[0] : ''
      const endTime = this.formInline.dateRange && this.formInline.dateRange.length ? this.formInline.dateRange[1] : ''
      this.$http.get(url.getLogininforList, {
        params: {
          orgId: this.formInline.orgId,
          userName: this.formInline.userName,
          beginTime,
          endTime,
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
      }).then(res => {
        this.loading = false
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || []
          this.total = res.data.data.total || 0
        }
      }).catch(() => {
        this.loading = false
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
      this.loading = true
      this.getList()
    },
    handleCurrentChange(val) {
      this.pageNum = val
      this.loading = true
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
</style>
